import React, {useState} from 'react';
import {connect, DispatchProp} from "react-redux";
import {withTranslation, useTranslation} from "react-i18next";
import {ReactComponent as BackSVG} from "../../../../images/icons/arrow-left.svg";
import {RootState} from "../../../../reducers";
import ErrorFormAlertView from "../../../components/Common/ErrorFormAlertView";
import ErrorFormView from "../../../components/Common/ErrorFormView";
import ErrorFormHelper from "../../../utils/ErrorFormHelper";
import {getUser} from "../../../services/User/reducer";
import {useAuth} from "../../../services/User/auth";
import handleException from "../../../services/Api/handleException";

interface OwnProps {
    setPage: (page?: string) => void;
    onHide: () => void;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

function UserEditDrawer(props: Props) {
    const [phoneNumber, setPhoneNumber] = useState(props.user.phone_number);
    const [name, setName] = useState(props.user.name);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState([] as any[]);
    const authService = useAuth();
    const {t} = useTranslation();

    const save = async () => {
        setLoading(true);
        try {
            await authService.updateUser({
                phone_number: phoneNumber,
                name: name
            });
            setLoading(false);
            props.setPage(undefined);
        } catch (e) {
            let errors = handleException(e);
            setErrors(errors);
            setLoading(false);
        }

    }
    return (
            <div>
                <div className={"user-header-top top"}>
                    <button onClick={() => props.setPage(undefined)} className={"btn-back"} aria-label={t("common.action.back")}>
                        <BackSVG aria-hidden="true" />
                    </button>
                    <h3>
                        {t("modules.user.field.data.title")}
                    </h3>
                </div>
                <div className={"container mx-0 p-0 my-2"}>
                    <div>
                        <h5 className="mb-4">{t("common.word.your_data")}</h5>
                        <ErrorFormAlertView errors={errors}/>
                        <div className="form-group">
                            <input type="text" onChange={(e) => setName(e.target.value)} value={name}
                                   className={"form-control" + ErrorFormHelper(errors, "name")}
                                   placeholder={t("common.word.full_name")}
                                   aria-label={t("common.word.full_name")} aria-describedby="account-name"/>
                            <label htmlFor="account-name">{t("common.word.full_name")}</label>
                            <ErrorFormView errors={errors} field="name"/>
                        </div>
                    </div>
                    <div>
                        <ErrorFormAlertView errors={errors}/>
                        <div className="form-group">
                            <input type="text" onChange={(e) => setPhoneNumber(e.target.value)} value={phoneNumber}
                                   className={"form-control" + ErrorFormHelper(errors, "phone_number")}
                                   placeholder={t("common.word.phone_number")}
                                   aria-label={t("common.word.phone_number")} aria-describedby="account-phone"/>
                            <label htmlFor="account-phone">{t("common.word.phone_number")}</label>
                            <ErrorFormView errors={errors} field="phone_number"/>
                        </div>
                    </div>
                    <button
                        className={"btn-spinner btn-block btn-primary btn w-100 btn-submit" + (loading ? ' loading' : '')}
                        onClick={save}>
                        <span className="left spinner-border spinner-border-sm"/>
                        {t("common.action.save")}
                    </button>
                </div>
            </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    user: getUser(state.user)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(UserEditDrawer));